// extracted by mini-css-extract-plugin
module.exports = {"account":"UserInfo_account__3iEkx"};